module.exports = __webpack_public_path__ + "static/Dinesh_Kashyap-167fecdc2fb222267e9706c87f6e31ff.jpg";